/**
 * 站点配置工具函数
 * 用于获取 public/config.js 中的配置项
 */

// 获取完整配置对象
export function getConfig() {
  return window.SITE_CONFIG || {}
}

// 获取公司信息
export function getCompanyInfo(locale = 'zh') {
  const config = getConfig()
  const company = config.company || {}
  return {
    name: company.name?.[locale] || company.name?.zh || 'Nebula Global LLC',
    brand: company.brand || 'SCGIDC',
    address: company.address || '',
    phone: company.phone || '',
    description: company.description?.[locale] || company.description?.zh || '',
    slogan: company.slogan?.[locale] || company.slogan?.zh || ''
  }
}

// 获取邮箱
export function getEmail(type = 'support') {
  const config = getConfig()
  return config.emails?.[type] || `${type}@nebulaglobal.net`
}

// 获取所有邮箱
export function getEmails() {
  const config = getConfig()
  return config.emails || {
    support: 'support@nebulaglobal.net',
    legal: 'legal@nebulaglobal.net',
    privacy: 'privacy@nebulaglobal.net',
    abuse: 'abuse@nebulaglobal.net',
    dmca: 'dmca@nebulaglobal.net',
    sales: 'sales@nebulaglobal.net'
  }
}

// 获取外部链接
export function getLink(type = 'clientArea') {
  const config = getConfig()
  return config.links?.[type] || ''
}

// 获取所有外部链接
export function getLinks() {
  const config = getConfig()
  return config.links || {}
}

// 获取 API 配置
export function getApiConfig() {
  const config = getConfig()
  return config.api || {
    baseUrl: 'https://95008.com/api',
    cdnUrl: 'https://cdn.95008.com',
    timeout: 30000
  }
}

// 获取版权信息
export function getCopyright(locale = 'zh') {
  const config = getConfig()
  const copyright = config.copyright || {}
  const startYear = copyright.startYear || 2024
  const endYear = copyright.endYear || new Date().getFullYear()
  const holder = copyright.holder || 'Nebula Global LLC'
  
  const yearRange = startYear === endYear ? `${endYear}` : `${startYear}-${endYear}`
  
  return {
    startYear,
    endYear,
    holder,
    text: `Copyright © ${yearRange} ${holder}. All Rights Reserved.`
  }
}

// 获取功能开关
export function getFeature(feature) {
  const config = getConfig()
  return config.features?.[feature] ?? true
}

// 获取社交媒体链接
export function getSocialLinks() {
  const config = getConfig()
  return config.social || {}
}

// 导出一个响应式的配置对象 (用于 Vue 组件)
import { reactive, computed } from 'vue'

export function useConfig() {
  const config = reactive(getConfig())
  
  return {
    config,
    getCompanyName: (locale) => config.company?.name?.[locale] || config.company?.name?.zh,
    getEmail: (type) => config.emails?.[type],
    getLink: (type) => config.links?.[type],
    copyright: computed(() => getCopyright())
  }
}

export default {
  getConfig,
  getCompanyInfo,
  getEmail,
  getEmails,
  getLink,
  getLinks,
  getApiConfig,
  getCopyright,
  getFeature,
  getSocialLinks,
  useConfig
}
